



import React from "react";
import Slider from "react-slick";
import { Box, Typography } from "@mui/material";
import data from "../components/projectdata";
import "../css/projectslideshow.css";
const AutoScrollingCarousel = () => {
return(
  <div>
  

  <div class="logos">
      <div class="logos-slide">
      {data.map((item) => (
          
              <img src={item.img} alt={item.name} />
          

        ))}
      </div>

      <div class="logos-slide">
      {data.map((item) => (
            
            
            <img src={item.img} alt={item.name} />
        
           

        ))}
      </div>
    </div>
  </div>
)
};

export default AutoScrollingCarousel;